<template>
	<v-card class="FilterView">
		<v-layout class="ma-4" row>
			<v-flex xs12>
				<p class="text-center">
					<b>Total Number of {{ viewStatus }} Forms:</b>
					<i>{{ getCountOfForms }}</i>
				</p>
			</v-flex>

			<v-flex xs12>
				<v-row class="mt-2" justify="center">
					<v-select
						v-if="['admin', 'groot'].includes(userRole)"
						class="ma-2 site-filter-select"
						:class="viewStatus === 'Site' ? 'showFilter' : ''"
						:style="{ width: mobileSize ? '40%' : '22%' }"
						:items="sitesDropdown"
						item-value="site"
						item-text="site"
						:value="
							viewStatus === 'All' || siteFilter === 'Site' ? null : siteFilter
						"
						placeholder="Site"
						:disabled="dataLoading"
						solo
						flat
						dense
						hide-details
						append-icon=""
						@change="locationSetter"
					>
						<template v-if="viewStatus === 'Site'" v-slot:prepend-inner>
							<font-awesome-icon
								class="site-filter-select__arrow"
								:class="viewStatus === 'Site' ? 'arrow' : ''"
								:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							/>
						</template>
						<template v-slot:item="{ item }">
							{{ item.site }} {{ item.hospital ? "Hospital" : "" }}
						</template>
						<template v-slot:selection="{ item }">
							{{ item.site }} {{ item.hospital ? "Hospital" : "" }}
						</template>
					</v-select>

					<v-btn
						v-else
						class="ma-2"
						:width="mobileSize ? '40%' : '40%'"
						:class="viewStatus === 'Site' ? 'showFilter' : ''"
						@click="retrieveForms"
						:disabled="dataLoading"
					>
						<font-awesome-icon
							:class="viewStatus == 'Site' ? 'arrow' : ''"
							:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							v-if="viewStatus === 'Site'"
						/>
						{{ filterLocation }}
					</v-btn>

					<v-menu transition="scale-transition">
						<template v-slot:activator="{ on }">
							<v-btn
								class="ma-2"
								:width="mobileSize ? '40%' : '22%'"
								v-on="on"
								:class="wasteFilter !== 'Waste Type' ? 'showFilter' : ''"
								:disabled="dataLoading"
							>
								<span>{{ wasteFilter }}</span>
							</v-btn>
						</template>
						<v-list>
							<v-list-item
								class="pt-3 pl-5"
								v-for="waste in wasteTypes"
								:key="waste"
								@click="filterButton(waste, 'Waste Type')"
							>
								<v-list-item-title v-text="waste"></v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>

					<!-- Chargeable -->
					<v-btn
						v-if="!mobileSize"
						:disabled="dataLoading"
						class="ma-2"
						:class="filterType == 'Chargeable' ? 'showFilter' : ''"
						:width="mobileSize ? '40%' : '22%'"
						@click="filterButton('Chargeable')"
					>
						<span>Chargeable</span>
					</v-btn>
					<v-btn
						v-if="!mobileSize && ['admin', 'groot'].includes(userRole)"
						class="ma-2"
						:class="viewStatus == 'All' ? 'showFilter' : ''"
						:width="mobileSize ? '40%' : '22%'"
						@click="showFilters('All')"
						:disabled="dataLoading"
					>
						<span>
							<font-awesome-icon
								:class="viewStatus == 'All' ? 'arrow' : ''"
								v-if="viewStatus === 'All'"
								:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							/> </span
						>All
					</v-btn>

					<v-btn
						class="ma-2"
						:class="viewStatus == 'Open' ? 'showFilter' : ''"
						:width="mobileSize ? '40%' : '22%'"
						@click="showFilters('Open')"
						:disabled="viewStatus === 'All' || dataLoading"
					>
						<span>
							<font-awesome-icon
								v-if="viewStatus === 'Open'"
								:class="viewStatus == 'Open' ? 'arrow' : ''"
								:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							/> </span
						>Open
					</v-btn>

					<v-btn
						class="ma-2"
						:class="viewStatus == 'Closed' ? 'showFilter' : ''"
						:width="mobileSize ? '40%' : '22%'"
						@click="showFilters('Closed')"
						:disabled="viewStatus === 'All' || dataLoading"
					>
						<span>
							<font-awesome-icon
								:class="viewStatus == 'Closed' ? 'arrow' : ''"
								v-if="viewStatus === 'Closed'"
								:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							/> </span
						>Closed
					</v-btn>
					<v-btn
						class="FilterView__CNC"
						:class="viewStatus == 'Closed Not Completed' ? 'showFilter' : ''"
						@click="showFilters('Closed Not Completed')"
						:disabled="viewStatus === 'All' || dataLoading"
					>
						<span>
							<font-awesome-icon
								v-if="viewStatus === 'Closed Not Completed'"
								:class="viewStatus == 'Closed Not Completed' ? 'arrow' : ''"
								:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							/> </span
						>Closed Not Completed
					</v-btn>
					<v-btn
						class="ma-2"
						:class="viewStatus == 'On Hold' ? 'showFilter' : ''"
						:width="mobileSize ? '40%' : '22%'"
						@click="showFilters('On Hold')"
						:disabled="viewStatus === 'All' || dataLoading"
					>
						<span>
							<font-awesome-icon
								v-if="viewStatus === 'On Hold'"
								:class="viewStatus == 'On Hold' ? 'arrow' : ''"
								:icon="sortAsc ? 'arrow-up' : 'arrow-down'"
							/> </span
						>On Hold
					</v-btn>

					<!-- Mobile View -->
					<v-btn
						v-if="mobileSize"
						:disabled="dataLoading"
						class="ma-2"
						:class="filterType == 'Chargeable' ? 'showFilter' : ''"
						:width="mobileSize ? '40%' : '22%'"
						@click="filterButton('Chargeable')"
					>
						<span>Chargeable</span>
					</v-btn>
				</v-row>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
export default {
	name: "FilterView",
	props: [
		"viewStatus",
		"getCountOfForms",
		"showFilters",
		"sortAsc",
		"siteFilter",
		"sitesDropdown",
		"wasteFilter",
		"wasteTypes",
		"filterButton",
		"mobileSize",
		"userRole",
		"locationSetter",
		"filterLocation",
		"retrieveForms",
		"filterType",
		"dataLoading",
	],
};
</script>

<style>
.FilterView {
	padding: 8px;
	width: 100%;
}
.FilterView__CNC {
	display: none;
}
.showFilter {
	background-color: rgb(0, 128, 122) !important;
	color: white !important;
}
.arrow {
	color: white !important;
}

.showFilter.site-filter-select .v-input__slot {
	background-color: rgb(0, 128, 122) !important;
}

.showFilter.site-filter-select .v-select__selection,
.showFilter.site-filter-select input,
.showFilter.site-filter-select .v-label {
	color: white !important;
}

.site-filter-select {
	flex: none;
}

.site-filter-select.v-text-field.v-text-field--solo .v-input__control {
	min-height: 36px;
}

.site-filter-select.v-text-field.v-text-field--solo .v-input__slot {
	min-height: 36px !important;
	margin-bottom: 0;
	padding: 0 16px !important;
	border-radius: 4px !important;
	box-shadow:
		0px 3px 1px -2px rgba(0, 0, 0, 0.2),
		0px 2px 2px 0px rgba(0, 0, 0, 0.14),
		0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
	background: #e0e0e0 !important;
}

.site-filter-select .v-text-field__slot,
.site-filter-select .v-select__slot {
	justify-content: center;
	text-align: center;
}

.site-filter-select .v-select__selection {
	margin: 0;
	max-width: 100%;
	justify-content: center;
	font-size: 0.875rem;
	font-weight: 500;
}

.site-filter-select .v-input__prepend-inner {
	margin-top: 0;
	margin-right: 4px;
	align-self: center;
}

.site-filter-select__arrow {
	font-size: 0.875rem;
}

@media only screen and (min-width: 600px) {
	.FilterView__CNC {
		display: unset;
		margin: 8px;
		width: 22%;
	}
}
</style>
